import React, { useEffect } from 'react';
import Tippy from '@tippyjs/react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import { connect } from 'react-redux';
import { map } from 'lodash';

import { getCaseManagements, resetCaseManagements } from "../../../redux/actions/managementActions";

const headers = ['Fecha Gestión', 'Tipo Gestión', 'Comentario'];

let textLength = 25;

const CaseManagementHistory = (props) => {
  const { getCaseManagements, caseManagements, resetCaseManagements, setManagements, params } = props;

  useEffect(() => {
    getCaseManagements(params.id, (res) => { setManagements(res) });
    return () => resetCaseManagements();
  }, [getCaseManagements, resetCaseManagements, params]);

  return (
    <div className="crm-history-container">
      <div className="crm-history-table-container">
        {caseManagements.entry.length > 0 &&
          <table>
            <thead>
              <tr>
                {map(headers, (e, index) => (<th key={`thead-${index}`} className="crm-header-case-field">{e}</th>))}
              </tr>
            </thead>
            <tbody>
              {map(caseManagements.entry, (e, index) => (
                <tr key={`tbody-${index}`}>
                  <td className="crm-body-case-field">{moment(e.createdAt).format('DD-MM-YYYY, HH:mm')}</td>
                  <td className="crm-body-case-field">{e.typeId.name}</td>
                  <Tippy
                    content={e.description}
                    disabled={e.description.length <= textLength}
                    placement='bottom'
                  >
                    <td className="crm-body-case-field">{e.description.length <= textLength ? e.description : `${e.description.slice(0, textLength - 1)}...`}</td>
                  </Tippy>
                </tr>
              ))}
            </tbody>
          </table>
        }
        {caseManagements.loading &&
          <div className="crm-gestion-empty">Obteniendo Gestiones...</div>
        }
        {!caseManagements.loading && !caseManagements.entry.length &&
          <div className="crm-gestion-empty">Aún no hay Gestiones</div>
        }
      </div>
    </div >
  );
};

CaseManagementHistory.propTypes = {
  getCaseManagements: PropTypes.func,
  resetCaseManagements: PropTypes.func,
  setManagements: PropTypes.func,
  caseManagements: PropTypes.shape({
    entry: PropTypes.array,
    loading: PropTypes.bool,
  }).isRequired,
  params: PropTypes.object,
};

const mapStateToProps = ({ management }) => ({
  caseManagements: management.caseManagements,
});

const mapDispatchToProps = { getCaseManagements, resetCaseManagements };

export default connect(mapStateToProps, mapDispatchToProps)(CaseManagementHistory);